import { Observable } from "rxjs";

import GwCurrency from "../GwCurrency/GwCurrency";
import MoneyExchangerInterface from "./MoneyExchangerInterface";

class LegacyMoneyExchanger implements MoneyExchangerInterface {
    constructor(
        private readonly baseCurrency: string,
        private readonly gwCurrency: GwCurrency
    ) {}
    exchange(amount: number, targetCurrency: string): Observable<number> {
        return this.gwCurrency.convert(
            amount,
            this.baseCurrency,
            targetCurrency
        );
    }
}

export default LegacyMoneyExchanger;
